import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

const AdminNavbar = ({ onLogout }) => {
    const history = useHistory();

    const handleLogout = () => {
        onLogout();
        history.push('/');
    };

    return (
        <AppBar position="sticky" sx={{ backgroundColor: '#4caf50' }}>
            <Toolbar>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Admin Dashboard
                </Typography>
                <Button color="inherit" onClick={() => history.push('/menu-maintenance')}>
                    Menu Maintenance
                </Button>
                <Button color="inherit" onClick={handleLogout}>
                    Logout
                </Button>
            </Toolbar>
        </AppBar>
    );
};

export default AdminNavbar;